import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.t('货物详情'),
      "width": 1000
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.listData,
      "bordered": ""
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (ref) {
        var index = ref.index;
        return _c('div', {}, [_vm._v(" " + _vm._s(index + 1) + " ")]);
      }
    }])
  }), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };